import React from 'react';
import { Formik, Form, Field, FormikProps } from 'formik';
import * as Yup from 'yup';
import Button from '../../common/Button/Button';
import { Spinner } from '../../common/Spinner/Spinner';
import styles from './LoginForm.module.css';

interface FormValues {
  username: string;
  password: string;
}

interface LoginFormProps {
  onSubmit: (values: FormValues) => Promise<void>;
  isLoading: boolean;
  error?: string;
}

const loginValidationSchema = Yup.object({
  username: Yup.string().min(3, 'Gebruikersnaam moet minimaal 3 karakters zijn').required('Gebruikersnaam is verplicht'),
  password: Yup.string().min(6, 'Wachtwoord moet minimaal 6 karakters zijn').required('Wachtwoord is verplicht'),
});

export const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, isLoading, error }) => {
  return (
    <Formik initialValues={{ username: '', password: '' }} validationSchema={loginValidationSchema} onSubmit={onSubmit}>
      {({ errors, touched, isValid, dirty }: FormikProps<FormValues>) => (
        <Form className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="username" className={styles.label}>
              Gebruikersnaam
            </label>
            <Field
              id="username"
              name="username"
              type="text"
              className={`${styles.input} ${errors.username && touched.username ? styles.inputError : ''}`}
              placeholder="Voer je gebruikersnaam in"
              disabled={isLoading}
            />
            {errors.username && touched.username && <div className={styles.fieldError}>{errors.username}</div>}
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password" className={styles.label}>
              Wachtwoord
            </label>
            <Field
              id="password"
              name="password"
              type="password"
              className={`${styles.input} ${errors.password && touched.password ? styles.inputError : ''}`}
              placeholder="Voer je wachtwoord in"
              disabled={isLoading}
            />
            {errors.password && touched.password && <div className={styles.fieldError}>{errors.password}</div>}
          </div>

          {error && <div className={styles.error}>{error}</div>}

          <Button type="primary" disabled={isLoading || !isValid || !dirty} className={styles.submitButton}>
            {isLoading ? <Spinner size="small" /> : 'Inloggen'}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export type { FormValues as LoginFormValues };
